// extracted by mini-css-extract-plugin
export var contrastLow = "_3f-1";
export var externalLink = "_3f-2";
export var externalLinkIcon = "_3f-3";
export var link = "_3f-0";
export var linkLabel = "_3f-4";